import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { default as OfertaEditado } from "../../components/Oferta/ofertaEditado";
import { usuarioSelector } from "../../selectors/sessionSelector";
import { compress, calculateNewSize } from "../../components/Common/imageCompressor";
import moment from "moment";
import { ofertaSelector } from "../../selectors/ofertaSelector";
import * as ofertaActions from "../../reducers/OfertaReducer/actions";
import _axios from "../../apiClient";

class OfertaEditadoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oferta: undefined, //oferta: undefinded,//this.props.oferta.oferta ? this.props.oferta.oferta : undefined, //this.props.oferta.oferta,
      preOferta: undefined,
      cargandoOferta: true,
      error: undefined,
      idOfertaSelected:
        this.props.dataContenido.ofertas && this.props.dataContenido.ofertaSelected
          ? this.props.dataContenido.ofertaSelected
          : undefined,
      usuarioCargado: false,
      ofertasCargadas: this.props.dataContenido.ofertas ? true : false,
      nombre: undefined,
      ofertaSelected: this.props.dataContenido.ofertas
        ? this.props.dataContenido.ofertas.find(
            (x) => x.idOferta === this.props.dataContenido.ofertaSelected
          )
        : undefined,
      tag: undefined,
      pathImg: undefined,
      currentFile: undefined,
      idOferta: undefined,
      fechaDesde: undefined,
      fechaHasta: undefined,
      datos: undefined,
      nombrePrev: undefined,
      tagPrev: undefined,
      fechaDesdePrev: undefined,
      fechaHastaPrev: undefined,
      pathImgPrev: undefined,
      editDatos: false,
      editImagen: false,
    };

    this.props.sagaGetOfertas();
  }

  setEditDatos = (e) => {
    this.setState({
      editDatos: e,
    });
  };

  setEditImagen = (e) => {
    this.setState({
      editImagen: e,
    });
  };

  validateTag(tag) {
    var re = /^\w+$/;
    return re.test(String(tag).toUpperCase());
  }

  validateTagExists(tag1) {
    if (this.props.dataContenido.ofertas) {
      var item = this.props.dataContenido.ofertas.find((x) => x.tag === tag1);
      if (item !== undefined) {
        return true;
      } else {
        return false;
      }
    }
  }

  componentDidUpdate = async () => {
    if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuario.idRol === 4) {
          window.location.hash = "/Pedidos";
        }
      });
    }

    const idOferta = this.props.match.params.idOferta;
    if (!this.state.datos) {
      await _axios
        .get(`/api/Oferta/GetOfertaById?id=${idOferta}`)

        .then((response) => {
          this.setState({ datos: response.data });
        })
        .catch((error) => {
          const data = error.response.data;
          throw data;
        });
    }

    if (this.state.datos && this.state.idOferta !== this.state.datos.idOferta) {
      if (this.state.datos.desde && this.state.datos.hasta) {
        const fecha1 = this.state.datos.desde.split(" ")[0];
        const dia1 = fecha1.split("/")[0];
        const mes1 = fecha1.split("/")[1];
        const anio1 = fecha1.split("/")[2];
        const fecha2 = this.state.datos.hasta.split(" ")[0];
        const dia2 = fecha2.split("/")[0];
        const mes2 = fecha2.split("/")[1];
        const anio2 = fecha2.split("/")[2];
        this.setState({
          fechaDesde: moment(new Date(`${mes1}/${dia1}/${anio1}`)).format("YYYY-MM-DD"),
          fechaHasta: moment(new Date(`${mes2}/${dia2}/${anio2}`)).format("YYYY-MM-DD"),
          fechaDesdePrev: moment(new Date(`${mes1}/${dia1}/${anio1}`)).format("YYYY-MM-DD"),
          fechaHastaPrev: moment(new Date(`${mes2}/${dia2}/${anio2}`)).format("YYYY-MM-DD"),
        });
      }
      this.setState({
        nombre: this.state.datos.nombre,
        nombrePrev: this.state.datos.nombre,
        idOfertaSelected: this.state.datos.idOferta,
        pathImg: this.state.datos.pathImagen,
        currentFile: this.state.datos.pathImagen,
        pathImgPrev: this.state.datos.pathImagen,
        tag: this.state.datos.tag || "",
        tagPrev: this.state.datos.tag || "",
        idOferta: this.state.datos.idOferta,
        ofertaSelected: this.props.dataContenido.ofertas
          ? this.props.dataContenido.ofertas.find((x) => x.idOferta === this.state.datos.idOferta)
          : null,
      });
    }
    localStorage.setItem(
      "idOfertaSelected",
      JSON.stringify({ idOfertaSelected: this.state.datos.idOferta })
    );
  };

  UNSAFE_componentWillReceiveProps() {
    /*
            if (this.state.cargandoOferta && nextProps.oferta.oferta.id!==undefined){
            this.setState({oferta: nextProps.oferta.oferta, preOferta: nextProps.oferta.oferta, cargandoOferta:false}, ()=>{this.render()})
            }
            this.render()
        */
    /*
        if (this.state.cargandoOferta && nextProps.oferta.id!==undefined){
        this.setState({oferta: nextProps.oferta.oferta, preUsuario: nextProps.oferta.oferta, cargandoOferta:false}, ()=>{this.render()})
        }
        this.render()
        */
  }

  valido() {
    let error = { valido: true };
    if (this.state.nombre === "" || this.state.nombre === null || this.state.nombre === undefined) {
      error.nombre = "debe definir un nombre";
      error.valido = false;
    }
    if (this.state.nombre !== undefined && this.state.nombre.length > 255) {
      error.nombre = "Logitud máxima es de 255 caracteres";
      error.valido = false;
    }
    if (this.state.tag === undefined || this.state.tag === "" || this.state.tag === null) {
      error.tag = "Ingrese un tag para la oferta";
      error.valido = false;
    }
    if (this.state.tag !== undefined && this.state.tag.length > 50) {
      error.tag = "Logitud máxima es de 50 caracteres";
      error.valido = false;
    }
    if (this.state.tag !== "" && !this.validateTag(this.state.tag)) {
      error.tag = "Debe definir un tag sin espacios en blanco y sin caracteres especiales";
      error.valido = false;
    }
    if (
      this.state.tag !== "" &&
      this.validateTagExists(this.state.tag) &&
      this.state.tag !== undefined &&
      this.state.tag !== this.state.datos.tag
    ) {
      error.tag = "Ya existe en el sistema una oferta con el mismo tag. Debe ingresar un nuevo tag";
      error.valido = false;
    }
    if (this.state.pathImg === undefined || this.state.currentFile === undefined) {
      error.pathImg = "Debe arrastrar o elegir una imagen";
      error.valido = false;
    }
    if (!this.state.fechaDesde) {
      const fecha1 = this.state.fechaDesde.split(" ")[0];
      const dia1 = fecha1.split("/")[0];
      const mes1 = fecha1.split("/")[1];
      const anio1 = fecha1.split("/")[2];
      if (dia1 === "" || mes1 === "" || anio1 === "") {
        error.fechaDesde = "Debe ingresar una fecha";
        error.valido = false;
      }
    }
    if (!this.state.fechaHasta) {
      const fecha2 = this.state.fechaHasta.split(" ")[0];
      const dia2 = fecha2.split("/")[0];
      const mes2 = fecha2.split("/")[1];
      const anio2 = fecha2.split("/")[2];
      if (dia2 === "" || mes2 === "" || anio2 === "") {
        error.fechaHasta = "Debe ingresar una fecha";
        error.valido = false;
      }
    }
    if (moment(this.state.fechaHasta).isBefore(this.state.fechaDesde)) {
      error.fechaHasta = "Debe ser mayor o igual a la fecha de inicio.";
      error.valido = false;
    }
    if (error.valido) {
      this.setState({ error: undefined });
      return true;
    } else {
      this.setState({ error });
      return false;
    }
  }

  handleOnSave = async (guardarDatos) => {
    if (this.valido()) {
      this.setState({
        cargandoOferta: false,
        nombrePrev: this.state.nombre,
        tagPrev: this.state.tag,
        fechaDesdePrev: this.state.fechaDesde,
        fechaHastaPrev: this.state.fechaHasta,
        pathImgPrev: this.state.pathImg,
      });
      let payload = {
        idOferta: this.state.idOferta,
        nombre: this.state.nombre,
        file: this.state.currentFile,
        tag: this.state.tag,
        fechaDesde: this.state.fechaDesde,
        fechaHasta: this.state.fechaHasta,
      };

      /*
            payload.callback = () => {
                this.props.history.goBack();
                //window.location.hash = '/Oferta'
            }
            */

      this.props.sagaPutOferta(payload);

      if (guardarDatos) this.setEditDatos(false);
      else this.setEditImagen(false);
    } else if (this.state.error) {
      if (guardarDatos) this.setEditDatos(true);
      else this.setEditImagen(true);
    }
  };

  handleOnClickDia = (fecha) => {
    this.setState(fecha);
  };

  handleOnChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [name]: value,
    });
  };

  handleOnDropFile = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length !== 0) {
      if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.");
      if (rejectedFiles.length > 1)
        Notification.showError("Se permite solo una imagen como portada de catálogo.");
    } else {
      if (acceptedFiles.length !== 0) {
        let currentFile = acceptedFiles[0];

        //let ofertaSelected = this.state.ofertaSelected

        // genero una imagen para conocer sus dimesiones
        let _self = this;
        let img = new Image();
        img.onload = function () {
          let width = this.width;
          let height = this.height;

          // comprimo la imagen
          let newSize = calculateNewSize(width, height, width * 2, height * 2);
          compress(
            currentFile,
            currentFile.name,
            newSize.width,
            newSize.height,
            _self.onImageCompressed
          );
        };
        img.src = URL.createObjectURL(currentFile);
      }
    }
  };

  onImageCompressed = (currentFile) => {
    //guardo en el estado una copia, para usarla al momento de guardar los recortes
    let currentFileCopy = currentFile;
    let file = URL.createObjectURL(currentFile);

    this.setState({
      pathImg: file,
      currentFile: currentFileCopy,
      error: { ...this.state.error, imagen: "" },
    });
  };

  render() {
    return (
      <OfertaEditado
        getPreOferta={() => {
          this.setState({
            nombre: this.state.nombrePrev,
            tag: this.state.tagPrev,
            fechaDesde: this.state.fechaDesdePrev,
            fechaHasta: this.state.fechaHastaPrev,
            error: { valido: undefined },
          });
        }}
        getPreImagen={() => {
          this.setState({
            pathImg: this.state.pathImgPrev,
            error: { valido: undefined },
          });
        }}
        idOferta={this.state.idOferta}
        ofertas={this.props.dataContenido.ofertas}
        ofertaSelected={this.state.ofertaSelected}
        nombre={this.state.nombre}
        tag={this.state.tag}
        fechaDesde={this.state.fechaDesde}
        fechaHasta={this.state.fechaHasta}
        error={this.state.error}
        pathImg={this.state.pathImg}
        handleOnChange={this.handleOnChange}
        handleOnSave={(guardarDatos) => {
          this.handleOnSave(guardarDatos);
        }}
        handleOnCancel={() => {
          this.props.history.goBack();
        }}
        handleOnDropFile={this.handleOnDropFile}
        handleOnClickDia={this.handleOnClickDia}
        preOferta={this.state.preOferta}
        setEditDatos={(newEdit) => {
          this.setEditDatos(newEdit);
        }}
        setEditImagen={(newEdit) => {
          this.setEditImagen(newEdit);
        }}
        editDatos={this.state.editDatos}
        editImagen={this.state.editImagen}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...ofertaActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuario: usuarioSelector(state),
    dataContenido: ofertaSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfertaEditadoContainer);
